<template>
  <div class="appointDiv-modify" @click="hideLicenseKeyBoard">
    <div class="cont1">
      <div class="left">选择厂区<span style="color: red;">*</span></div>
      <div
        :style="
          areaValue == '请选择厂区' ? 'flex: 2.1;color: #c8c9cc;' : 'flex: 2.1;'
        "
        @click="areaShow = true"
      >
        {{ areaValue }}
      </div>
      <div class="right" @click="areaShow = true">
        <van-icon
          name="arrow-down"
          style="line-height: 55px;"
          color="#b2b2b2"
        />
      </div>
    </div>
    <div class="cont1">
      <div class="left">选择业务<span style="color: red;">*</span></div>
      <div
        :style="
          businessValue == '请选择业务'
            ? 'flex: 2.1;color: #c8c9cc;'
            : 'flex: 2.1;'
        "
        @click="businessShow = true"
      >
        {{ businessValue }}
      </div>
      <div class="right" @click="businessShow = true">
        <van-icon
          name="arrow-down"
          style="line-height: 55px;"
          color="#b2b2b2"
        />
      </div>
    </div>
    <!-- 选择厂区 -->
    <van-action-sheet v-model="areaShow">
      <van-picker
        show-toolbar
        :columns="areaColumns"
        @change="onChangeArea"
        @cancel="onCancel"
        @confirm="onConfirmArea"
      />
    </van-action-sheet>
    <!-- 选择业务 -->
    <van-action-sheet v-model="businessShow">
      <van-picker
        show-toolbar
        :columns="businessColumns"
        @change="onChangeBusiness"
        @cancel="onCancel"
        @confirm="onConfirmBusiness"
      />
    </van-action-sheet>

    <div class="cont2">
      <div>涉及产品线(可多选)<span style="color: red;">*</span></div>
      <div
        :class="item.selected === true ? 'tabblk-active' : 'tabblk'"
        v-for="(item, index) in proLineColumms"
        :key="index"
        @click="SelectProLine(item)"
      >
        {{ item.name }}
      </div>
    </div>

    <div class="cont1">
      <div class="left">预约时间<span style="color: red;">*</span></div>
      <div
        :style="
          timeValue == '请选择预约时间'
            ? 'flex: 2.1;color: #c8c9cc;'
            : 'flex: 2.1;'
        "
        @click="timeShow = true"
      >
        {{ timeValue }}
      </div>
      <div class="right" @click="timeShow = true">
        <van-icon
          name="arrow-down"
          style="line-height: 55px;"
          color="#b2b2b2"
        />
      </div>
    </div>
    <van-calendar
      v-model="timeShow"
      color="#009967"
      type="range"
      @confirm="onConfirmTime"
      row-height="58"
      :show-title="false"
      :round="false"
    />

    <div class="cont3">
      <div class="car-license">
        <div class="car-license-title">请选择车牌</div>
        <div
          :class="isActive1 ? 'car-license-btn-active' : 'car-license-btn'"
          @click="changeBtn"
        >
          普通车牌
        </div>
        <div
          :class="isActive2 ? 'car-license-btn-active' : 'car-license-btn'"
          @click="changeBtn"
        >
          新能源车牌
        </div>
        <div class="car-license-title">请输入车牌号</div>
        <LicenseKeyBorad
          :type="licenseType"
          ref="licenseKeyBoard"
          @setLicense="setLicense"
          :showRecentUse="true"
          @click.stop="showLicenseKeyBoard"
        />
      </div>
    </div>

    <div class="cont1">
      <div class="left">车辆类型<span style="color: red;">*</span></div>
      <div
        :style="
          vehicleValue == '请选择车辆类型'
            ? 'flex: 2.1;color: #c8c9cc;'
            : 'flex: 2.1;'
        "
        @click="vehicleShow = true"
      >
        {{ vehicleValue }}
      </div>
      <div class="right" @click="vehicleShow = true">
        <van-icon
          name="arrow-down"
          style="line-height: 55px;"
          color="#b2b2b2"
        />
      </div>
    </div>
    <!-- 车辆类型 -->
    <van-action-sheet v-model="vehicleShow">
      <van-picker
        show-toolbar
        :columns="vehicleColumns"
        @change="onChangeVehicle"
        @cancel="onCancel"
        @confirm="onConfirmVehicle"
      />
    </van-action-sheet>

    <div class="cont4">
      <van-cell-group class="requried">
        <van-field
          v-model="driver.name"
          label="司机姓名"
          placeholder="请输入真实姓名"
        />
        <van-field
          v-model="driver.cardNum"
          label="司机身份证"
          placeholder="请输入身份证"
        />
        <van-field
          v-model="driver.phone"
          label="司机手机号"
          placeholder="请输入手机号"
        />
      </van-cell-group>
    </div>

    <div class="cont5">
      <div style="margin-bottom: 14px;">
        司机身份证正反面照片<span style="color: red;">*</span>
        <span style="font-size: 13px;float: right;color: #00C8D2;"
          >查看拍照指引
          <van-icon name="arrow" style="vertical-align: text-top;" />
        </span>
      </div>
      <van-uploader v-model="fileList1" :max-count="1" :afterRead="afterRead">
        <template #default>
          <div class="card-img-div">
            <div class="card-img-div-icon">
              <van-icon name="add-o" style="font-size: 23px;" /><br />
              身份证正面照片
            </div>
          </div>
        </template>
      </van-uploader>
      <span style="width: 10px;display: inline-block;"></span>
      <van-uploader v-model="fileList2" :max-count="1" :afterRead="afterRead">
        <template #default>
          <div class="card-img-div">
            <div class="card-img-div-icon">
              <van-icon name="add-o" style="font-size: 23px;" /><br />
              身份证反面照片
            </div>
          </div>
        </template>
      </van-uploader>
    </div>

    <div class="cont5">
      <div style="margin-bottom: 14px;">
        行驶证主页和副页照片<span style="color: red;">*</span>
        <span style="font-size: 13px;float: right;color: #00C8D2;"
          >查看拍照指引
          <van-icon name="arrow" style="vertical-align: text-top;" />
        </span>
      </div>
      <van-uploader v-model="fileList1" :max-count="1" :afterRead="afterRead">
        <template #default>
          <div class="card-img-div">
            <div class="card-img-div-icon">
              <van-icon name="add-o" style="font-size: 23px;" /><br />
              行驶证主页照片
            </div>
          </div>
        </template>
      </van-uploader>
      <span style="width: 10px;display: inline-block;"></span>
      <van-uploader v-model="fileList2" :max-count="1" :afterRead="afterRead">
        <template #default>
          <div class="card-img-div">
            <div class="card-img-div-icon">
              <van-icon name="add-o" style="font-size: 23px;" /><br />
              行驶证副页照片
            </div>
          </div>
        </template>
      </van-uploader>
    </div>

    <div class="cont5">
      <div style="margin-bottom: 14px;">
        驾驶证主页和副页照片<span style="color: red;">*</span>
        <span style="font-size: 13px;float: right;color: #00C8D2;"
          >查看拍照指引
          <van-icon name="arrow" style="vertical-align: text-top;" />
        </span>
      </div>
      <van-uploader v-model="fileList1" :max-count="1" :afterRead="afterRead">
        <template #default>
          <div class="card-img-div">
            <div class="card-img-div-icon">
              <van-icon name="add-o" style="font-size: 23px;" /><br />
              驾驶证主页照片
            </div>
          </div>
        </template>
      </van-uploader>
      <span style="width: 10px;display: inline-block;"></span>
      <van-uploader v-model="fileList2" :max-count="1" :afterRead="afterRead">
        <template #default>
          <div class="card-img-div">
            <div class="card-img-div-icon">
              <van-icon name="add-o" style="font-size: 23px;" /><br />
              驾驶证副页照片
            </div>
          </div>
        </template>
      </van-uploader>
    </div>

    <div class="cont6">
      <div style="padding: 0px 16px;">
        备注(选填)
      </div>
      <van-field
        v-model="remarks"
        rows="1"
        autosize
        type="textarea"
        placeholder="请输入留言"
      />
    </div>

    <div style="height: 130px;background-color: #f4f5f6;"></div>
    <div class="footer-cont2">
      <van-button
        type="primary"
        block
        class="btnStyle1"
        @click="saveAppointAndAdd"
        >保存并继续添加</van-button
      >
      <van-button block class="btnStyle2" @click="saveAppoint">保存</van-button>
    </div>
  </div>
</template>
<script>
import LicenseKeyBorad from "../../../components/license";
// import { Toast } from "vant";
export default {
  components: {
    LicenseKeyBorad
  },
  data() {
    return {
      areaShow: false,
      businessShow: false,
      timeShow: false,
      vehicleShow: false,
      areaColumns: ["红塔(前山厂)", "华丰(高栏厂)"],
      businessColumns: ["成品出厂", "成品入厂", "原料入厂"],
      proLineColumms: [
        {
          name: "第一期",
          selected: false
        },
        {
          name: "第二期",
          selected: false
        },
        {
          name: "第三期",
          selected: false
        }
      ],
      vehicleColumns: ["货柜车", "平板车", "槽罐车", "其它"],
      areaValue: "请选择厂区",
      businessValue: "请选择业务",
      timeValue: "请选择预约时间",
      vehicleValue: "请选择车辆类型",
      proLineSelect: [], // 产品线选择
      isActive1: true,
      isActive2: false,
      licenseType: "normal",
      licenseValue: "", //车牌值
      driver: {
        name: "",
        cardNum: "",
        phone: ""
      },
      fileList1: [],
      fileList2: [],
      remarks: ""
    };
  },
  methods: {
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      console.log(file);
    },
    onChangeArea(picker, values) {
      picker.setColumnValues(1, this.unit[values[0]]);
    },

    onChangeBusiness(picker, values) {
      picker.setColumnValues(1, this.unit[values[0]]);
    },

    onChangeVehicle(picker, values) {
      picker.setColumnValues(1, this.unit[values[0]]);
    },

    onCancel() {
      this.areaShow = false;
      this.businessShow = false;
      this.vehicleShow = false;
    },

    // 确认选择厂区
    onConfirmArea(val) {
      console.log(val);
      this.areaValue = val;
      this.areaShow = false;
    },

    // 确认选择业务
    onConfirmBusiness(val) {
      console.log(val);
      this.businessValue = val;
      this.businessShow = false;
    },

    // 确认选择车辆类型
    onConfirmVehicle(val) {
      console.log(val);
      this.vehicleValue = val;
      this.vehicleShow = false;
    },

    // 选择产品线
    SelectProLine(item) {
      this.proLineSelect = [];
      item.selected = !item.selected;
      for (let i = 0; i < this.proLineColumms.length; i++) {
        if (this.proLineColumms[i].selected) {
          this.proLineSelect.push(this.proLineColumms[i].name);
        }
      }
    },

    // 确认选择时间
    onConfirmTime(val) {
      console.log(val);
    },

    // 切换按钮
    changeBtn() {
      this.isActive1 = !this.isActive1;
      this.isActive2 = !this.isActive2;
      if (this.isActive1) {
        this.licenseType = "normal";
      } else {
        this.licenseType = "newEnergy";
      }
      this.$refs.licenseKeyBoard.emptyArray(); //清空内容
    },

    // 获取键盘数据
    setLicense(first, numArr) {
      this.licenseValue = first + numArr.join("");
      console.log(this.$common.isLicensePlate(this.licenseValue));
    },

    // 隐藏键盘
    hideLicenseKeyBoard() {
      if (!this.isAddPerson) {
        this.$refs.licenseKeyBoard.close_keyboard();
      }
    },

    // 弹起键盘
    showLicenseKeyBoard() {
      if (!this.isAddPerson) {
        this.$refs.LicenseKeyBorad.clickShowKeyboard();
      }
    },

    // 保存预约信息
    saveAppoint() {
      setTimeout(() => {
        this.$common.mbToastSuccess(`提交成功`);
        setTimeout(() => {
          // Toast({
          //   message: "保存失败，该预约时间已约满，请重新选择时间！",
          //   className: "toastEDE"
          // });
          this.$common.mbToastFail(
            `保存失败，该预约时间已约满，请重新选择时间！`
          );
        }, 2000);
      }, 2000);
    },

    // 保存并继续添加
    saveAppointAndAdd() {
      setTimeout(() => {
        this.$common.mbToastSuccess(`提交成功`);
      }, 2000);
    }
  },
  created() {}
};
</script>
<style lang="less" scoped>
.appointDiv-modify {
  min-height: calc(100vh - 1px);
  border-top: 1px solid #f4f5f6;
  background: #f4f5f6;
  font-size: 14px;
  .cont1 {
    line-height: 54px;
    background: #fff;
    font-size: 14px;
    display: flex;
    padding: 0px 15px;
    margin-bottom: 10px;
    .left {
      flex: 1;
    }
    .right {
      flex: 0.5;
      text-align: right;
    }
  }
  .cont2 {
    padding: 20px 16px;
    background: #fff;
    margin-bottom: 10px;
    .tabblk-active {
      display: inline-block;
      background: #00c8d2;
      color: #fff;
      margin: 14px 20px 0px 0px;
      padding: 5px 12px;
      border-radius: 20px;
    }
    .tabblk {
      display: inline-block;
      background: #f7f7f7;
      color: #999999;
      margin: 14px 20px 0px 0px;
      padding: 5px 12px;
      border-radius: 20px;
    }
  }
  .cont3 {
    padding: 10px 16px;
    background: #fff;
    margin-bottom: 10px;
    .car-license {
      &-title {
        font-size: 15px;
        line-height: 43px;
        margin: 0px 0px 10px;
      }
      &-btn-active {
        display: inline-block;
        background: #00c8d2;
        color: white;
        font-size: 13px;
        padding: 9px 18px;
        border-radius: 4px;
        margin: 0px 20px 10px 0px;
      }
      &-btn {
        display: inline-block;
        background: #f6f6f7;
        color: #00c8d2;
        font-size: 13px;
        padding: 9px 18px;
        border-radius: 4px;
        margin: 0px 20px 10px 0px;
      }
    }
  }
  .cont4 {
    margin-bottom: 10px;
  }

  .cont5 {
    background: #fff;
    margin-bottom: 10px;
    padding: 16px;
    font-size: 15px;
  }
  .card-img-div {
    color: #999999;
    font-size: 14px;
    background: #f4f5f6;
    display: inline-block;
    object-fit: cover;
    width: calc((100vw - 42px) / 2);
    height: calc((100vw - 42px) / 3.4);
    vertical-align: text-bottom;
    &-icon {
      text-align: center;
      top: 50%;
      position: relative;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .card-img {
    object-fit: cover;
    vertical-align: top;
    width: calc((100vw - 42px) / 2);
    height: calc((100vw - 42px) / 3.4);
  }

  .cont6 {
    background: #fff;
    padding: 16px 0px;
  }
}
</style>
<style lang="less">
.van-button--round {
  border-radius: 4px;
}
.van-calendar__popup.van-popup--bottom,
.van-calendar__popup.van-popup--top {
  height: 71%;
}

.van-uploader__preview {
  margin: 0px;
}
.van-uploader__preview-image {
  width: inherit;
  height: inherit;
  object-fit: cover;
  vertical-align: top;
  width: calc((100vw - 42px) / 2);
  height: calc((100vw - 42px) / 3.4);
}
</style>
